import { useLegacyStore } from '@warp-drive/legacy';
import { JSONAPICache } from '@warp-drive/json-api';
import { DefaultCachePolicy } from '@warp-drive/core/store';
import { Gate, MetaDocHandler } from '@warp-drive/utilities/handlers';
import { getOwner, setOwner } from '@ember/owner';
import AuthHandler from '../handlers/auth-handler';
import { ApiHostHandler } from '../handlers/api-host-handler';
import { JSONAPINormalizer } from '../handlers/json-api-normalizer';
import { UserSchema } from '../schemas/user';
import { ItemSchema } from '../schemas/item';
import { CreatorSchema } from '../schemas/creator';
import { ContentSourceSchema } from '../schemas/content-source';
import { PodcastSchema } from '../schemas/podcast';
import { RecipeSchema } from '../schemas/recipe';
import { MentionSchema } from '../schemas/mention';
import { ItemStatsSchema } from '../schemas/item-stats';
import { SummarySchema } from '../schemas/summary';
import { UserItemSchema } from '../schemas/user-item';
import { UserSourceSchema } from '../schemas/user-source';
import { TagSchema } from '../schemas/tag';
import type Owner from '@ember/owner';

export default {
  create(args: unknown[]) {
    const owner = getOwner(args) as Owner;
    const authHandler = new AuthHandler();
    setOwner(authHandler, owner);

    const Store = useLegacyStore({
      linksMode: true,
      cache: JSONAPICache,
      policy: new DefaultCachePolicy({
        apiCacheSoftExpires: 5 * 60 * 1000,
        apiCacheHardExpires: 30 * 60 * 1000,
      }),
      schemas: [
        UserSchema,
        ItemSchema,
        CreatorSchema,
        ContentSourceSchema,
        PodcastSchema,
        RecipeSchema,
        MentionSchema,
        ItemStatsSchema,
        SummarySchema,
        UserItemSchema,
        UserSourceSchema,
        TagSchema,
      ],
      handlers: [
        ApiHostHandler,
        authHandler,
        MetaDocHandler,
        new Gate(
          JSONAPINormalizer,
          (context) => !context.request.options?.isMetaRequest
        ),
      ],
    });

    const store = new Store(args);

    return store;
  },
};
